(() => {
  function initHeader(header) {
    if (header.dataset.initialized) return;
    header.dataset.initialized = 'true';

    const backdrop = header.querySelector('[data-drawer-backdrop]');
    const drawers = [...header.querySelectorAll('[data-drawer]')];
    const panelDuration = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--panel-motion-duration')) * 1000;
    let activeDrawer = null;
    let opener = null;
    let closeTimer;
    let closingDrawer = null;

    function closeDrawer(immediate = false) {
      if (!activeDrawer) return;
      const drawer = activeDrawer;
      clearTimeout(closeTimer);
      if (closingDrawer) closingDrawer.hidden = true;
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      drawer.inert = true;
      const finishClose = () => {
        drawer.hidden = true;
        backdrop.hidden = true;
        closingDrawer = null;
      };
      if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finishClose();
      else {
        closingDrawer = drawer;
        closeTimer = setTimeout(finishClose, panelDuration);
      }
      document.body.classList.remove('drawer-open');
      opener?.setAttribute('aria-expanded', 'false');
      if (!immediate) opener?.focus();
      activeDrawer = null;
      opener = null;
    }

    function openDrawer(name, button) {
      closeDrawer(true);
      clearTimeout(closeTimer);
      if (closingDrawer) closingDrawer.hidden = true;
      closingDrawer = null;
      activeDrawer = drawers.find((drawer) => drawer.dataset.drawer === name);
      if (!activeDrawer) return;
      opener = button;
      activeDrawer.hidden = false;
      activeDrawer.inert = false;
      backdrop.hidden = false;
      activeDrawer.offsetWidth;
      activeDrawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.classList.add('drawer-open');
      button?.setAttribute('aria-expanded', 'true');
      (activeDrawer.querySelector('[data-search-input]') || activeDrawer.querySelector('[data-drawer-close]'))?.focus();
    }

    header.querySelectorAll('[data-drawer-open]').forEach((button) => {
      button.addEventListener('click', event => { event.preventDefault(); openDrawer(button.dataset.drawerOpen, button); });
    });
    document.querySelectorAll('[data-mobile-search-shortcut]').forEach((button) => {
      button.addEventListener('click', () => openDrawer('search', button));
    });
    header.querySelectorAll('[data-drawer-close]').forEach((button) => button.addEventListener('click', () => closeDrawer()));
    backdrop.addEventListener('click', () => closeDrawer());
    header.addEventListener('keydown', (event) => {
      if (!activeDrawer) return;
      if (event.key === 'Escape') closeDrawer();
      if (event.key !== 'Tab') return;
      const focusable = [...activeDrawer.querySelectorAll('a, button, input')].filter((item) => !item.closest('[hidden], [inert]'));
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    header.querySelectorAll('[data-submenu-toggle]').forEach((button) => {
      const owner = button.closest('li');
      const list = owner.querySelector('.site-drawer__sublist');
      const backRow = document.createElement('li');
      const back = document.createElement('button');
      back.type = 'button';
      back.className = 'site-drawer__back';
      back.textContent = `‹  ${owner.querySelector('.site-drawer__link-row a').textContent.trim()}`;
      backRow.append(back);
      list.prepend(backRow);
      let submenuTimer;
      function toggle(opening) {
        clearTimeout(submenuTimer);
        const parentList = owner.parentElement;
        [...parentList.children].forEach((item) => { if (item !== owner) item.inert = opening; });
        owner.querySelector('.site-drawer__link-row').inert = opening;
        list.hidden = false;
        list.inert = !opening;
        button.setAttribute('aria-expanded', String(opening));
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : panelDuration;
        list.offsetWidth;
        list.classList.toggle('is-open', opening);
        if (opening) back.focus();
        else { button.focus(); if (!duration) list.hidden = true; else submenuTimer = setTimeout(() => { list.hidden = true; }, duration); }
      }
      button.addEventListener('click', () => toggle(true));
      back.addEventListener('click', () => toggle(false));
    });
    header.querySelectorAll('.site-mega-menu').forEach((menu) => {
      const categories = [...menu.querySelectorAll('[data-mega-category]')];
      categories.forEach((category) => {
        const activate = () => categories.forEach((item) => item.classList.toggle('is-active', item === category));
        category.addEventListener('mouseenter', activate);
        category.addEventListener('focusin', activate);
      });
      menu.addEventListener('mouseleave', () => categories.forEach((category) => category.classList.remove('is-active')));
      menu.addEventListener('focusout', (event) => { if (!menu.contains(event.relatedTarget)) categories.forEach((category) => category.classList.remove('is-active')); });
    });

    header.querySelectorAll('[data-predictive-search]').forEach((container) => {
      const input = container.querySelector('[data-search-input]');
      const results = container.querySelector('[data-search-results]');
      const trending = container.querySelector('[data-trending]');
      const placeholder = input.placeholder;
      let timer;
      let controller;

      function clearResults(showTrending = false) {
        const mobileSearchOpen = container.closest('[data-drawer="search"]')?.classList.contains('is-open');
        if (mobileSearchOpen && !input.value.trim()) showTrending = true;
        clearTimeout(timer);
        controller?.abort();
        results.hidden = true;
        results.replaceChildren();
        const showPills = showTrending && !!trending?.querySelector('a');
        input.setAttribute('aria-expanded', String(showPills));
        input.setAttribute('aria-controls', showPills ? trending.id : results.id);
        input.placeholder = showTrending && !container.closest('[data-drawer="search"]') ? '' : placeholder;
        if (trending) trending.hidden = !showPills;
      }
      input.addEventListener('focus', () => {
        if (!input.value.trim()) clearResults(true);
        else { input.placeholder = ''; input.dispatchEvent(new Event('input')); }
      });

      function addText(tag, className, value, parent) {
        const element = document.createElement(tag);
        element.className = className;
        element.textContent = value;
        parent.append(element);
        return element;
      }

      input.addEventListener('input', () => {
        clearTimeout(timer);
        controller?.abort();
        const query = input.value.trim();
        if (!query) { clearResults(true); return; }
        if (trending) trending.hidden = true;
        input.placeholder = '';
        timer = setTimeout(async () => {
          controller = new AbortController();
          const endpoint = header.dataset.searchUrl;
          const url = new URL(endpoint.endsWith('.json') ? endpoint : `${endpoint}.json`, location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '3');
          try {
            const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error(`Search failed: ${response.status}`);
            const data = await response.json();
            if (input.value.trim() !== query) return;
            const products = data.resources?.results?.products || [];
            results.replaceChildren();
            addText('p', 'predictive-results__heading', 'Product Results', results);
            if (products.length === 0) addText('p', 'predictive-results__empty', 'No products found', results);
            products.forEach((product) => {
              const item = document.createElement('a');
              item.className = 'predictive-results__item';
              item.href = product.url;
              if (product.featured_image?.url) {
                const image = document.createElement('img');
                image.src = product.featured_image.url;
                image.alt = '';
                image.loading = 'lazy';
                item.append(image);
              }
              const details = document.createElement('span');
              addText('strong', '', product.title, details);
              if (product.price != null) {
                const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
                  style: 'currency', currency: header.dataset.currency || 'PKR'
                }).format(Number(product.price));
                addText('small', '', amount, details);
              }
              item.append(details);
              results.append(item);
            });
            const all = addText('a', 'predictive-results__all', 'View All Results', results);
            all.href = `${header.dataset.searchPage}?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last`;
            results.hidden = false;
            input.setAttribute('aria-expanded', 'true');
            input.setAttribute('aria-controls', results.id);
            if (trending) trending.hidden = true;
          } catch (error) {
            if (error.name !== 'AbortError') clearResults();
          }
        }, 220);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { clearResults(); input.blur(); }
        if (event.key === 'ArrowDown') {
          const panel = !results.hidden ? results : trending && !trending.hidden ? trending : null;
          if (panel) { event.preventDefault(); panel.querySelector('a')?.focus(); }
        }
      });
      container.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { clearResults(); input.blur(); }
      });
      container.addEventListener('focusout', (event) => { if (!container.contains(event.relatedTarget)) clearResults(); });
      document.addEventListener('click', (event) => {
        if (!container.contains(event.target)) clearResults();
      });
    });
  }

  function initSlider(slider) {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';
    const slides = [...slider.querySelectorAll('.hero-slideshow__slide')];
    const dots = [...slider.querySelectorAll('[data-slide-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    let startX;
    let editorSelected = false;
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');

    let pendingSlide = 0;
    function loadSlide(position) {
      const slide = slides[position];
      const template = slide.querySelector('[data-slide-media]');
      if (template) template.replaceWith(template.content);
      return slide.querySelector('img');
    }

    async function show(next) {
      const position = (next + slides.length) % slides.length;
      const request = ++pendingSlide;
      const image = loadSlide(position);
      if (image && !image.complete) {
        try { await image.decode(); } catch { /* Keep navigation available if an image fails. */ }
      }
      if (request !== pendingSlide || !slider.isConnected) return;
      index = position;
      slides.forEach((slide, position) => {
        const active = position === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        const link = slide.querySelector('a');
        if (link) link.tabIndex = active ? 0 : -1;
      });
      dots.forEach((dot, position) => {
        const active = position === index;
        dot.setAttribute('aria-selected', String(active));
        dot.tabIndex = active ? 0 : -1;
      });
      loadSlide((index + 1) % slides.length);
    }

    const firstImage = slides[0].querySelector('img');
    if (!firstImage || firstImage.complete) loadSlide(1);
    else firstImage.addEventListener('load', () => loadSlide(1), { once: true });

    function stop() { clearInterval(timer); timer = undefined; }
    function start() {
      stop();
      if (slider.dataset.autoplay !== 'true' || reduceMotion.matches || document.hidden || editorSelected || slider.matches(':focus-within')) return;
      timer = setInterval(() => show(index + 1), Number(slider.dataset.delay) || 5000);
    }
    slider.querySelector('[data-slide-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
    slider.querySelector('[data-slide-next]')?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot, position) => dot.addEventListener('click', () => { show(position); start(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', (event) => { if (!slider.contains(event.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    reduceMotion.addEventListener('change', start);
    slider.addEventListener('touchstart', (event) => { startX = event.touches[0]?.clientX; }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      const delta = startX - event.changedTouches[0]?.clientX;
      if (Math.abs(delta) > 45) { show(index + (delta > 0 ? 1 : -1)); start(); }
    }, { passive: true });
    slider.addEventListener('shopify:block:select', (event) => {
      const selected = slides.indexOf(event.target.closest('.hero-slideshow__slide'));
      if (selected >= 0) { editorSelected = true; stop(); show(selected); }
    });
    slider.addEventListener('shopify:block:deselect', () => { editorSelected = false; start(); });
    start();
  }

  function initTrendingProducts(section) {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const tabs = [...section.querySelectorAll('[data-product-tab]')];
    const panels = [...section.querySelectorAll('[data-product-panel]')];
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const sliders = panels.map((panel) => {
      const track = panel.querySelector('[data-products-track]');
      const dots = panel.querySelector('[data-products-dots]');
      const previous = panel.querySelector('[data-products-prev]');
      const next = panel.querySelector('[data-products-next]');
      let pages = [];
      function go(position) { track.scrollTo({ left: position, behavior: reduceMotion.matches ? 'instant' : 'smooth' }); }
      function update() {
        if (panel.hidden) return;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        previous.hidden = next.hidden = max <= 2;
        const active = pages.reduce((best, page, index) => Math.abs(page - track.scrollLeft) < Math.abs(pages[best] - track.scrollLeft) ? index : best, 0);
        [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
      }
      function layout() {
        if (panel.hidden) return;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const first = track.firstElementChild;
        const step = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap) : track.clientWidth;
        const perPage = Math.max(1, Math.round(track.clientWidth / step));
        pages = [0];
        for (let position = step * perPage; position < max - 2; position += step * perPage) pages.push(position);
        if (max > 2) pages.push(max);
        dots.replaceChildren();
        if (pages.length > 1) pages.forEach((position, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Show product page ${index + 1}`);
          dot.addEventListener('click', () => go(position));
          dots.append(dot);
        });
        update();
      }
      previous.addEventListener('click', () => go([...pages].reverse().find((position) => position < track.scrollLeft - 2) ?? 0));
      next.addEventListener('click', () => go(pages.find((position) => position > track.scrollLeft + 2) ?? pages.at(-1)));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(layout).observe(track);
      return { layout };
    });
    function select(index) {
      tabs.forEach((tab, position) => { tab.setAttribute('aria-selected', String(position === index)); tab.tabIndex = position === index ? 0 : -1; });
      panels.forEach((panel, position) => { panel.hidden = position !== index; });
      sliders[index]?.layout();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); select(next); tabs[next].focus();
      });
    });
    section.addEventListener('shopify:block:select', (event) => {
      const index = panels.indexOf(event.target.closest('[data-product-panel]'));
      if (index >= 0) select(index);
    });
    select(0);
  }

  function init() {
    document.querySelectorAll('[data-site-header]').forEach(initHeader);
    document.querySelectorAll('[data-hero-slider]').forEach(initSlider);
    document.querySelectorAll('[data-trending-products]').forEach(initTrendingProducts);
    document.querySelectorAll('[data-health-categories]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const button = section.querySelector('.health-categories__action button');
      const extraItems = section.querySelectorAll('.health-categories__item--extra');
      if (!button) return;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        extraItems.forEach((item) => { item.hidden = !expanded; });
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      });
      section.addEventListener('shopify:block:select', (event) => {
        if (!event.target.closest('.health-categories__item--extra')) return;
        extraItems.forEach((item) => { item.hidden = false; });
        button.setAttribute('aria-expanded', 'true');
        button.textContent = button.dataset.less;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
